<template>
  <v-edit-dialog
    v-if="column.editable"
    :return-value.sync="value"
    persistent
    large
    @save="save"
  >
    <v-layout>{{ formattedDate }}</v-layout>
    <template v-slot:input>
      <v-date-picker
        :label="column.label"
        v-model="value"
        locale="ru"
        :first-day-of-week="1"
      >
      </v-date-picker>
    </template>
  </v-edit-dialog>
  <v-layout v-else>{{ formattedDate }}</v-layout>
</template>

<script>
import entities from "../../api/entities";

export default {
  name: "DateColumn",
  computed: {
    formattedDate() {
      const date = new Date(this.value);
      return date.toLocaleDateString("ru-RU");
    }
  },
  props: ["entity_type", "entity", "column", "value"],
  methods: {
    async save() {
      if (this.column.editable) {
        const data = {};
        data[this.column.name] = this.value;
        const result = await entities.update(
          this.token,
          this.entity_type,
          this.entity.id,
          data
        );
        const color = result.success ? "green" : "red";
        this.$root.$emit(
          "notify",
          result.message || "Успешно сохранено",
          color
        );
      }
    }
  }
};
</script>

<style scoped></style>
